export default "__VITE_ASSET__38lXkyFi__"